import React from 'react';
import { IOldIconProps } from './type';

const BurgerMenu: React.FC<IOldIconProps> = ({ width, height, ...props }) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0.769231C0 0.344396 0.258297 0 0.576923 0H19.4231C19.7417 0 20 0.344396 20 0.769231C20 1.19407 19.7417 1.53846 19.4231 1.53846H0.576923C0.258297 1.53846 0 1.19407 0 0.769231Z" />
      <path d="M0 8C0 7.57517 0.258297 7.23077 0.576923 7.23077H19.4231C19.7417 7.23077 20 7.57517 20 8C20 8.42483 19.7417 8.76923 19.4231 8.76923H0.576923C0.258297 8.76923 0 8.42483 0 8Z" />
      <path d="M0.576923 14.4615C0.258297 14.4615 0 14.8059 0 15.2308C0 15.6556 0.258297 16 0.576923 16H19.4231C19.7417 16 20 15.6556 20 15.2308C20 14.8059 19.7417 14.4615 19.4231 14.4615H0.576923Z" />
    </svg>
  );
};

export default BurgerMenu;
